import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

export default {
  getHeaders () {
    const user = JSON.parse(sessionStorage.getItem('user'))

    return {
      id: user ? user.login : ''
    }
  },
  getHeadersForTextPlain () {
    const user = JSON.parse(sessionStorage.getItem('user'))

    return {
      id: user ? user.login : '',
      'content-type': 'text/plain'
    }
  },

  async login (credentials) {
    return axios.post('/users/login', credentials, { withCredentials: true })
  },

  async relogUserIfNecessary (credentials) {
    return axios.post('/users/relogUserIfNecessary', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async loginAs (credentials) {
    return axios.post('/users/runAs', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async releaseRunAs (credentials) {
    return axios.post('/users/releaseRunAs', credentials, { headers: this.getHeadersForTextPlain(), withCredentials: true })
  },

  async unblockUser (loginToUnblock) {
    return axios.post('/users/unblockUser', loginToUnblock, { headers: this.getHeadersForTextPlain(), withCredentials: true })
  },

  async unblockUserAdmin (loginToUnblock) {
    return axios.post('/users/unblockUserAdmin', loginToUnblock, { headers: this.getHeadersForTextPlain(), withCredentials: true })
  },

  async logout (userToLogOut) {
    return axios.post('/users/logout', userToLogOut, { headers: this.getHeadersForTextPlain(), withCredentials: true })
  },

  async forceLogout (userToLogOut) {
    return axios.post('/users/forceLogout', userToLogOut, { headers: this.getHeadersForTextPlain(), withCredentials: true })
  },

  async get (id) {
    return axios.get('/users/' + id, { headers: this.getHeaders(), withCredentials: true })
  },

  async update (id, user) {
    return axios.put('/users/' + id, user, { headers: this.getHeaders(), withCredentials: true })
  },

  async getUserList (credentials) {
    return axios.post('/users/list', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async getUserListLocked (credentials) {
    return axios.post('/users/listlocked', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async getUserAdminListLocked (credentials) {
    return axios.post('/users/adminlistlocked', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async getRoles (credentials) {
    return axios.post('/users/roles', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async getPeriodes (credentials) {
    return axios.post('/users/periodes', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async isPeriodeUpdatable (periodeId) {
    return axios.post('/users/isPeriodeUpdatable', periodeId, { headers: this.getHeadersForTextPlain(), withCredentials: true })
  },

  async getLogs (credentials) {
    return axios.post('/administration/adminlogs', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async getFileToDownload (fileName) {
    return axios.post('/administration/download/', fileName, { headers: this.getHeaders(), withCredentials: true })
  },

  async getBatchLogs (credentials) {
    return axios.post('/administration/batchlogs/', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async updateMail (credentials) {
    return axios.post('/users/updateMail/', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async getListeMajMails (credentials) {
    return axios.post('/administration/majMailAdmin/', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async createUser (credentials) {
    return axios.post('/users/createUser', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async generateLogin (credentials) {
    return axios.post('/users/generateLogin', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async deleteUser (userToDelete) {
    return axios.post('/users/deleteUser', userToDelete, { headers: this.getHeaders(), withCredentials: true })
  },

  async editUser (credentials) {
    return axios.post('/users/editUser', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async printDoc (credentials) {
    return axios.post('/administration/printDoc', credentials, { responseType: 'blob', headers: this.getHeaders(), withCredentials: true })
  },

  async lockUser (credentials) {
    return axios.post('/users/lockUser', credentials, { headers: this.getHeadersForTextPlain(), withCredentials: true })
  },

  async initXarmConf (credentials) {
    return axios.post('/users/initXarmConf', credentials, { headers: this.getHeadersForTextPlain(), withCredentials: true })
  },

  async deleteXarmConf (credentials) {
    return axios.post('/users/deleteXarmConf', credentials, { headers: this.getHeadersForTextPlain(), withCredentials: true })
  },

  async resetPassword (userToUpdate) {
    return axios.post('/users/resetPassword', userToUpdate, { headers: this.getHeaders(), withCredentials: true })
  },

  async checkIfUserLocked (credentials) {
    return axios.post('/users/checkIfUserLocked', credentials, { headers: this.getHeadersForTextPlain(), withCredentials: true })
  },

  async checkIfXarmConfigNotInitialized (credentials) {
    return axios.post('/users/checkIfXarmConfigNotInitialized', credentials, { headers: this.getHeadersForTextPlain(), withCredentials: true })
  },

  async getEntrepriseById (credentials) {
    return axios.post('/entreprise/getEntrepriseById', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async changePassword (credentials) {
    return axios.post('/users/changePassword', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async checkHistory (credentials) {
    return axios.post('/users/checkHistory', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async getInfoAccueil (credentials) {
    return axios.post('/users/infoBarAccueil', credentials, { headers: this.getHeadersForTextPlain() })
  },

  async getTokenForMessagerie (credentials) {
    return axios.post('/users/getTokenMessagerie', credentials, { headers: this.getHeadersForTextPlain(), withCredentials: true })
  }
}
